/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum SsoLoginStates {
    TestLogin = 'TestLogin',
}
